export default variables => variables;
